import { FieldPattern } from '..';

import { SELECT } from '../../../../constants/FieldTypeConstants';
import {
  DependentOnOptionConfigsType,
  DropdownOptionsType,
  FormFieldsType,
  TileUiThemeType
} from '../../../../types/FieldModelTypes';
import { prepareOptions } from '../../../../utils/FieldUtils';

import DependentField from '../DependentField';

class SelectField extends DependentField {
  readonly type: string = SELECT;
  options: Array<DropdownOptionsType>;
  enableDefaultSuggestion: boolean;
  isFieldDisabled: boolean;
  relevantLabel: string | undefined;
  dependentOnOptionConfigs: DependentOnOptionConfigsType | undefined;
  /** When set (e.g. TILE_UI), options render with the matching UI instead of the default picker. */
  optionsUI: string | undefined;
  /** Optional; when omitted and `options_UI` is TILE_UI, the default Figma theme is used. */
  tileUiTheme: TileUiThemeType | undefined;
  constructor(
    selectFieldData: FormFieldsType,
    initialValue: string | DropdownOptionsType = '',
    defaultOptions: Array<DropdownOptionsType> = []
  ) {
    super(selectFieldData, initialValue);

    this.options =
      selectFieldData.options &&
      (selectFieldData.options?.length > 0 ||
        Object.keys(selectFieldData.options).length > 0)
        ? selectFieldData.options.map((option) => prepareOptions(option))
        : defaultOptions;
    this.enableDefaultSuggestion =
      selectFieldData.enable_default_suggestion ?? false;
    this.isFieldDisabled = initialValue ? true : false;
    this.relevantLabel = selectFieldData.relevantLabel;
    this.dependentOnOptionConfigs = selectFieldData.dependent_on_option_configs;
    this.optionsUI = selectFieldData.options_UI;
    this.tileUiTheme = selectFieldData.tile_ui_theme;
  }
  match<T>(p: FieldPattern<T>): T {
    return p.SelectField(this);
  }
}

export default SelectField;
